import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../contexts/AuthContext/AuthContext';
import useFreePlanStatus from '../../hooks/useFreePlanStatus';
import './ExpiredPlanModal.css';

/**
 * Modal que bloqueia o acesso quando o plano FREE expira
 * Oferece opções para ver planos ou fazer logout
 */
export default function ExpiredPlanModal() {
  const navigate = useNavigate();
  const freeStatus = useFreePlanStatus();
  const { handleLogout } = useContext(AuthContext);
  
  // Não exibe se não está expirado
  if (!freeStatus.isExpired) {
    return null;
  }
  
  // Formatar data de expiração
  const formatDate = (isoDate) => {
    if (!isoDate) return '';
    return new Date(isoDate).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };
  
  const handleViewPlans = () => {
    navigate("/planos");
  };
  
  const getMessage = () => {
    const expirationDate = formatDate(freeStatus.expirationDate);
    
    if (freeStatus.isLegacyUser) {
      return `Você teve 3 anos de acesso gratuito ao Easyvog Plus. Seu período expirou${expirationDate ? ` em ${expirationDate}` : ''}. Para continuar usando todas as funcionalidades, escolha um de nossos planos.`;
    }
    
    return `Seu período de teste de 30 dias expirou${expirationDate ? ` em ${expirationDate}` : ''}. Para continuar usando o sistema, assine um de nossos planos.`;
  };
  
  return (
    <div className="expired-modal-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="expired-modal-content">
        <div className="expired-modal-icon-container">
          <svg 
            className="expired-modal-icon" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
        </div>
        
        <h2 className="expired-modal-title">
          Seu período gratuito expirou
        </h2>
        
        <p className="expired-modal-message">
          {getMessage()}
        </p>
        
        <div className="expired-modal-actions">
          <button 
            onClick={handleViewPlans} 
            className="expired-modal-button expired-modal-button-primary"
          >
            Ver Planos e Assinar
          </button>
          <button 
            onClick={handleLogout} 
            className="expired-modal-button expired-modal-button-secondary"
          >
            Sair
          </button>
        </div>
        
        <div className="expired-modal-footer">
          <p className="expired-modal-footer-text">
            Dúvidas? Entre em contato com nosso suporte.
          </p>
        </div>
      </div>
    </div>
  );
}
